import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '../internal/variants.js';
export function TierBadge({ level, sm = false, showLabel = true }) {
    return (_jsxs("span", { className: cx('tier', level, sm && 'sm'), title: 'TPM tier · ' + level, children: [_jsxs("span", { className: "ramp", "aria-hidden": "true", children: [_jsx("i", {}), _jsx("i", {}), _jsx("i", {}), _jsx("i", {})] }), showLabel && _jsx("span", { children: level })] }));
}
//# sourceMappingURL=TierBadge.js.map